import React from 'react'
import { IconTypeProps } from '../icon';

export function IconClose({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox='0 0 50 50'
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M30.7577 25.0007L48.3161 7.48325C49.085 6.71434 49.5169 5.67148 49.5169 4.58408C49.5169 3.49668 49.085 2.45382 48.3161 1.68491C47.5472 0.916007 46.5043 0.484039 45.4169 0.484039C44.3295 0.484039 43.2866 0.916007 42.5177 1.68491L25.0002 19.2432L7.48274 1.68491C6.71383 0.916007 5.67097 0.484039 4.58357 0.484039C3.49617 0.484039 2.45331 0.916007 1.68441 1.68491C0.915499 2.45382 0.483531 3.49668 0.483531 4.58408C0.483531 5.67148 0.915499 6.71434 1.68441 7.48325L19.2427 25.0007L1.68441 42.5183C1.30168 42.8978 0.997905 43.3495 0.7906 43.8471C0.583295 44.3447 0.476562 44.8784 0.476562 45.4174C0.476562 45.9565 0.583295 46.4902 0.7906 46.9878C0.997905 47.4854 1.30168 47.937 1.68441 48.3166C2.064 48.6993 2.51563 49.0031 3.01322 49.2104C3.51081 49.4177 4.04452 49.5244 4.58357 49.5244C5.12262 49.5244 5.65634 49.4177 6.15393 49.2104C6.65152 49.0031 7.10314 48.6993 7.48274 48.3166L25.0002 30.7582L42.5177 48.3166C42.8973 48.6993 43.349 49.0031 43.8465 49.2104C44.3441 49.4177 44.8779 49.5244 45.4169 49.5244C45.956 49.5244 46.4897 49.4177 46.9873 49.2104C47.4848 49.0031 47.9365 48.6993 48.3161 48.3166C48.6988 47.937 49.0026 47.4854 49.2099 46.9878C49.4172 46.4902 49.5239 45.9565 49.5239 45.4174C49.5239 44.8784 49.4172 44.3447 49.2099 43.8471C49.0026 43.3495 48.6988 42.8978 48.3161 42.5183L30.7577 25.0007Z" />
    </svg>
  );
}